import React, { Component } from 'react';
import InputForm from '../../../components/InputForm';
import LabelForm from '../../../components/LabelForm';

const ProcessData = (props)=>{
    return(
        <div className='col-xs-12 no-padding'>
            <fieldset>
                <legend>Datos del Proceso</legend>
                <div className='colxs-12 no-padding'>
                    <div className='col-xs-12 '>
                        {props.fields.map((field, i)=>
                            <div className='col-xs-12 col-sm-2' key={i} style={{paddingLeft:0}}>
                                <LabelForm text={field.label} />
                                <InputForm 
                                    id={field.id}
                                    value={field.value}
                                    handleChange={props.updateFields}
                                    // disabled
                                />
                            </div>
                        )}
                    </div>
                </div>
            </fieldset>
        </div>
    )
}

export default ProcessData;